<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Law Firms</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Elevate your law firm's online presence with LocalScale, the ultimate solution for targeted advertising</p>
                        <p>In the competitive world of legal services, being visible in your local community is paramount.</p>
                        <p>At LocalScale, we specialize in helping law firms like yours stand out where it matters most.</p>
                        <p>Whether you're a personal injury lawyer, family law attorney, or specialize in corporate law, our ad network empowers you to reach potential clients in the cities and neighborhoods that align with your practice areas.</p>
                        <p>With LocalScale, you'll not only increase your firm's visibility but also attract high-quality leads seeking legal expertise.</p>
                        <p>Let us amplify your firm's reach and ensure that your services are top-of-mind for those in need of legal counsel.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-legal.png" alt="Legal">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been a game-changer for our family law practice. Their targeted advertising helped us connect with individuals in our community facing challenging situations, leading to a significant increase in client inquiries. Thanks to LocalScale, we've been able to expand our reach and provide crucial legal support to those who need it most.”</h3>
                    <p class="testimonial-customer">– Alison Adler, Partner at Adler & Associates Family Law Firm</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
